export enum CloudProvider {
    None = 0,
    Aws = 1,
    Azure = 2,
    DigitalOcean = 3,
    Google = 4,
    Local = 5,
    OVH = 6   
}